import PropTypes from 'prop-types';
import React from 'react';
import {Label} from 'semantic-ui-react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

const IconLabel = ({
										 icon,
										 color,
										 content,
										 visible,
										 className,
										 link,
										 disabled,
										 onClick,
										 ...labelProps
									 }) => {
	const darken = color && color.indexOf('dark ') >= 0;
	const lighten = color && color.indexOf('light ') >= 0;
	const trueColor =
		(color &&
			(darken
				? color.substring(color.indexOf('dark ') + 5)
				: lighten
					? color.substring(color.indexOf('light ') + 6)
					: color)) ||
		undefined;
	return visible ? (
		<Label
			{...labelProps}
			{...(link
				? {
					as: NavLink,
					to: link,
					onClick: e => e.stopPropagation()
				}
				: { as: 'a' })}
			icon={icon.name ? icon : { name: icon }}
			content={content}
			onClick={disabled ? undefined : onClick}
			color={trueColor}
			className={cn(className, {
				disabled,
				iconOnly: !content,
				dark: darken,
				light: !darken && lighten
			})}
		/>
	) : null;
};

IconLabel.defaultProps = {
	content: null,
	visible: true
};

IconLabel.propTypes = {
	icon: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({ name: PropTypes.string.isRequired })
	]).isRequired,
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	visible: PropTypes.any
};
export default IconLabel;
